import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const FlagPoleIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M8.077.607c-.132.084-.63.376-1.402.376-.603 0-1.007-.15-1.44-.32-.442-.17-.894-.339-1.59-.339-.988 0-1.657.207-1.958.339v9.062h.47V5.057c.32-.094.82-.197 1.488-.197.602 0 .978.141 1.42.31.433.16.913.349 1.61.349.696 0 1.26-.302 1.665-.565l.104-.066V.362Zm-.104 4.018c-.263.16-.724.423-1.298.423-.603 0-1.007-.15-1.44-.32-.442-.17-.894-.339-1.59-.339-.64 0-1.13.085-1.487.189V.992c.32-.094.819-.197 1.487-.197.602 0 .988.14 1.43.31.433.16.913.348 1.61.348.554 0 .997-.131 1.298-.254v3.435z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const FlagPoleIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M8.077.607c-.132.084-.63.376-1.402.376-.603 0-1.007-.15-1.44-.32-.442-.17-.894-.339-1.59-.339-.988 0-1.657.207-1.958.339v9.062h.47V5.057c.32-.094.82-.197 1.488-.197.602 0 .978.141 1.42.31.433.16.913.349 1.61.349.696 0 1.26-.302 1.665-.565l.104-.066V.362Zm-.104 4.018c-.263.16-.724.423-1.298.423-.603 0-1.007-.15-1.44-.32-.442-.17-.894-.339-1.59-.339-.64 0-1.13.085-1.487.189V.992c.32-.094.819-.197 1.487-.197.602 0 .988.14 1.43.31.433.16.913.348 1.61.348.554 0 .997-.131 1.298-.254v3.435z" />
        </SvgIcon>
    );
};
